import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda, formatoMonto, validaMonto
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';


 
import axios from 'axios';
import useTableFijo from '../useTableFijo';
import { ModalAgregarRetenOrdenPago } from './modalAgregarRetenxOrdenPago';
import moment from 'moment';


function TablaRetenOrdenPago(props) {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Codigo', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Descripción', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Alicuota', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Total Retenido', textAlign: 'center' },
        { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Fecha', textAlign: 'center' },

    ]

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacionRete, setOperacionRete] = useState(0);
    const [records, setRecords] = useState([]);
    const [records1, setRecords1] = useState([]);
    const [habiBot, setHabiBot] = useState(false);
    const [retencionSel, setRetencionSel] = useState();
    const [itemSelect, setItemSelect] = useState(-1);
    const [totalRete, setTotalRete] = useState(false);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtMonto = useRef([]);
    const txtTotalRetenido = useRef();



    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const cerrarModal = () => {
        setMostrar(false);
        blanquearCampos()
    }


    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }


    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        blanquearCampos();
        setOperacionRete(ope);
        if (ope === 1) {
            if (props.itemselect >= 0) {
                setMostrar5(true);
            }
        } else if (ope === 2 && itemSelect >= 0) {
            setMostrar5(true);
        } else if (ope === 3) {
            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Está seguro de eliminar el registro?', icono: 'confirmacion' });
            //setMostrar5(true);
            //setIdtimbres(idtimbres.filter((it) => it.idtimbredetalle !== datos[i].idtimbredetalle));
        }

    }

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);

        console.log(datos);

        let data = [...records1];
        if (operacionRete === 1) {
            //for (let i = 0; i < datos.length; i++) {

            data.push({
                iddetalle: datos[0].iddetalle,
                numfactura: datos[0].numfactura,
                idtiporetencion: datos[0].idtiporetencion,
                descripcion: datos[0].descripcion,
                alicuota: datos[0].alicuota,
                totalrete: datos[0].totalrete,
                fecha: datos[0].fecha,
                tiporetencion: datos[0].tiporetencion,
            });

            //}
        } else {
            data[itemSelect].iddetalle = datos[0].iddetalle;
            data[itemSelect].numfactura = datos[0].numfactura;
            data[itemSelect].idtiporetencion = datos[0].idtiporetencion;
            data[itemSelect].descripcion = datos[0].descripcion;
            data[itemSelect].alicuota = datos[0].alicuota;
            data[itemSelect].totalrete = datos[0].totalrete;
            data[itemSelect].fecha = datos[0].fecha;
            data[itemSelect].tiporetencion = datos[0].tiporetencion;
        }
        var totRet = 0.00;
        for (let i = 0; i < data.filter((it) => it.numfactura === props.facturasel.numfactura).length; i++) {
            totRet = parseFloat(totRet) + parseFloat(data.filter((it) => it.numfactura === props.facturasel.numfactura)[i].totalrete);
        }
        totRet = Math.round(parseFloat(totRet) * Math.pow(10, 4)) / Math.pow(10, 4);
        setTotalRete(totRet);
        txtTotalRetenido.current.value = formatMoneda(totRet.toString().replace(',', '').replace('.', ','), ',', '.', 2);
        setRecords1(data);
        setRecords(data.filter((it) => it.numfactura === props.facturasel.numfactura));
        props.data(data);
    }

    useEffect(() => {
        
        blanquearCampos();
        if(props.operacion === 2 || props.operacion === 3){
            setHabiBot(true);
        } else if(props.operacion === 4){
            if (props.desde === 5){
                setHabiBot(false);
            } else {
                setHabiBot(true);
            }
        } else if(props.operacion === 1){
            setHabiBot(false);
        }
        if (props.datarecords.length > 0) {

            var data = [...props.datarecords];
            var datos = [];
            var totRet = 0.00;
            for (let i = 0; i < data.length; i++) {

                datos.push({
                    iddetalle: data[i].iddetalle,
                    numfactura: data[i].numfactura,
                    idtiporetencion: data[i].idtiporetencion,
                    descripcion: data[i].descripcion,
                    alicuota: data[i].alicuota,
                    totalrete: data[i].totalrete,
                    fecha: data[i].fecha,
                });
                if (props.facturasel){
                    if (data[i].numfactura === props.facturasel.numfactura) {
                        totRet = parseFloat(totRet) + parseFloat(data[i].totalrete);
                    }
                }
            }
            if (props.tipocomp === 13) {
                setHabiBot(true);
            } 
            totRet = Math.round(parseFloat(totRet) * Math.pow(10, 4)) / Math.pow(10, 4);
            setTotalRete(totRet);
            txtTotalRetenido.current.value = formatMoneda(totRet.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            setRecords1(datos);
            if (props.facturasel){
                setRecords(datos.filter((it) => it.numfactura === props.facturasel.numfactura));
                props.data(datos);
            }
        } else {
            setRecords([]);
            setRecords1([]);
        }

    }, [props.datarecords, props.facturasel, props.itemSelect]);

    const seleccionarFila = (index) => (e) => {
        if (props.operacion === 1 || (props.operacion === 4  && props.desde === 5)) {
            e.preventDefault();
            setItemSelect(index);
            setRetencionSel(records[index]);
            props.data(records1);
        } 

    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        if (operacionRete === 3) {
            let numfact = records[itemSelect].numfactura;
            let idret = records[itemSelect].idtiporetencion;
            let data = [...records.filter(function (it) {
                it.numfactura !== numfact && it.idtiporetencion !== idret;
            })];
            var totRet = 0.00;
            for (let i = 0; i < data.length; i++) {
                totRet = parseFloat(totRet) + parseFloat(data[i].totalrete);
            }
            totRet = Math.round(parseFloat(totRet) * Math.pow(10, 4)) / Math.pow(10, 4);
            setTotalRete(totRet);
            txtTotalRetenido.current.value = formatMoneda(totRet.toString().replace(',', '').replace('.', ','), ',', '.', 2);
            setRecords1(records1.filter(function (it) {
                it.numfactura !== numfact && it.idtiporetencion !== idret;
            }))
            setRecords(data);
            setItemSelect(0);
            setRetencionSel(data[0]);
            props.data(records1.filter(function (it) {
                it.numfactura !== numfact && it.idtiporetencion !== idret;
            }));
        } else {
            props.onHideEliminarRetIsrl();
            setMostrar5(true);
            //setOperacion(1);
            blanquearCampos()
        }
    };

    return (
        <div className='col-md-12 mx-auto px-0'>

            <ModalAgregarRetenOrdenPago
                show={mostrar5}
                operacion={operacionRete}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
                retencionsel={records[itemSelect]}
                retenciones={records}
                facturasel={props.facturasel}
                natural={props.natural}
                totalrete={totalRete}
                montoislr={props.montoislr}
            />
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <div className="col-12 p-0 m-0 d-flex flex-wrap">
                <div className="col-11 p-0 m-0">
                    <TblContainer container={{ height: 150, width: '100%', overflow: 'auto'}}>
                        <TblHead />
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item + item.idtiporetencion} className="table-bordered" style={{ padding: "0", height: '40px', cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "50px" }}>{item.idtiporetencion}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "60px" }}>{item.descripcion}</td>
                                        <td style={{ fontSize: "10px", textAlign: "right", width: "60px" }}>{formatMoneda(item.alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td style={{ fontSize: "10px", textAlign: "right", width: "60px" }}>{formatMoneda(item.totalrete.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "60px" }}>{moment.utc(item.fecha).format('DD/MM/YYYY')}</td>
                                    </tr>

                                ))
                            }
                        </tbody>
                    </TblContainer>
                </div>
                <div class="col-1 p-0 pl-2 m-0 d-flex flex-column justify-content-around">
                    <button onClick={opciones(1, '')} 
                        disabled={habiBot} 
                        className="p-lg-1 btn btn-primary btn-sm rounded d-flex justify-content-around align-items-center">
                        <span className='d-none d-lg-block'> INCLUIR</span><i className="pl-lg-1 fas fa-plus"></i> 
                    </button>
                    <button onClick={opciones(2, itemSelect)} 
                        disabled={habiBot} 
                        className="p-lg-1 btn btn-warning btn-sm rounded d-flex justify-content-around align-items-center">
                        <span className='d-none d-lg-block'> EDITAR</span><i className="pl-lg-1 fas fa-edit"></i> 
                    </button>
                    <button onClick={opciones(3, itemSelect)} 
                        disabled={habiBot} 
                        className="p-lg-1 btn btn-danger btn-sm rounded d-flex justify-content-around align-items-center">
                        <span className='d-none d-lg-block'> ELIMINAR</span><i className="pl-lg-1 fas fa-trash-alt"></i> 
                    </button>
                </div>
                <div className="col-6 col-lg-3 m-0 mt-2 ml-auto p-0 input-group input-group-sm">
                    <label className="input-group-text">
                        Total Retenido:
                    </label>
                    <input type="text" 
                        autoComplete='off' 
                        className="form-control text-right bg-transparent" 
                        disabled={true} 
                        ref={txtTotalRetenido} 
                        placeholder="0,00" 
                        id="monto" />
                </div>
            </div>
        </div>
    );

}

export default TablaRetenOrdenPago;
